<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="dg-stage">
        <svg class="dg-svg" viewBox="0 0 260 140" aria-hidden="true">
          <defs>
            <marker
              id="dg-arrow"
              viewBox="0 0 10 10"
              refX="8"
              refY="5"
              markerWidth="6"
              markerHeight="6"
              orient="auto-start-reverse"
            >
              <path d="M0,0 L10,5 L0,10 z" fill="rgba(15,15,20,0.45)" />
            </marker>
          </defs>
          <line
            x1="64"
            y1="40"
            x2="116"
            y2="40"
            stroke="rgba(15,15,20,0.45)"
            stroke-width="1.5"
            marker-end="url(#dg-arrow)"
          />
          <line
            x1="156"
            y1="56"
            x2="156"
            y2="92"
            stroke="rgba(15,15,20,0.45)"
            stroke-width="1.5"
            marker-end="url(#dg-arrow)"
          />
          <line
            x1="116"
            y1="108"
            x2="64"
            y2="108"
            stroke="rgba(15,15,20,0.45)"
            stroke-width="1.5"
            marker-end="url(#dg-arrow)"
          />
        </svg>
        <span class="dg-node dg-node--a">
          <span class="dg-bar"></span>
        </span>
        <span class="dg-node dg-node--b">
          <span class="dg-bar"></span>
        </span>
        <span class="dg-node dg-node--c">
          <span class="dg-bar"></span>
        </span>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewDiagram',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.dg-stage {
  position: relative;
  flex: 1;
  min-height: 150px;
}
.dg-svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.dg-node {
  position: absolute;
  display: grid;
  place-items: center;
  width: 56px;
  height: 30px;
  border-radius: 6px;
  background: white;
  border: 1.5px solid var(--accent);
}
.dg-bar {
  display: block;
  height: 5px;
  width: 60%;
  border-radius: 999px;
  background: color-mix(in srgb, var(--accent) 70%, rgba(15, 15, 20, 0.2));
}
.dg-node--a { top: 18%; left: 8%; }
.dg-node--b {
  top: 18%; right: 8%;
  background: color-mix(in srgb, var(--accent) 16%, white);
}
.dg-node--c { bottom: 18%; left: 8%; }
</style>
